import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { useSetting } from '../../util/useSetting';

const RESEARCHES = [
    {
        id: '1',
        name: '香港學生睡眠',
        image: '/secondary/tasks/r1.png',
        subtitle: '研究測試 A-1'
    },
    {
        id: '2',
        name: '機器人',
        image: '/secondary/tasks/r2.png',
        subtitle: '研究測試 2'
    },
      { 
    id: '3',
    name: '小販文化',
    image: '/secondary/tasks/p1.png',
    subtitle: '研究測試 B-1'
  },
  {
    id: '4',
    name: '香港學生運動',
    image: '/secondary/tasks/p2.png',
    subtitle: '研究測試 B-2'
  },
  { 
    id: '5',
    name: '孤獨感',
    image: '/secondary/tasks/p3.png',
    subtitle: '研究測試 C-1'
  },
  {
    id: '6',
    name: '香港氣候變化',
    image: '/secondary/tasks/p4.png',
    subtitle: '研究測試 C-2'
  },

]



function Component(props) {
    const { id } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(RESEARCHES.filter(item => item.id === id)?.[0])
    const [isLoading, setisLoading] = useState(false)
    const { fontSize } = useSetting();




    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        // let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        // if (result.result) {
        //     setdata(result.result)
        //     settotal(result.count || 0)
        // } else {
        //     alert('Fetch data error')
        // }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(fetchData, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])



    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px] overflow-auto' style={{ fontSize, backgroundImage: `url('/secondary/bg7.png')`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px] p-[16px]'>
                <div className='text-[#4B555C] font-[700] cursor-pointer' style={{ fontSize: fontSize + 4 }} onClick={() => { navigate('/platform2/research-practices') }}>{'< 返回 全部研究測試'}</div>
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-col w-full flex-wrap justify-between items-stretch font-[600]'>
                <img src={data?.image} alt={data?.name} className='w-full h-auto' />
                <div className='p-[16px] flex flex-col gap-[8px]'>
                    <div className='text-[#4B555C] font-[900]' style={{ fontSize: fontSize + 4 }}>{data?.name}</div>
                    <div className='text-[#4B555C] font-[600]' style={{ fontSize: fontSize }}>{data?.subtitle}</div>
                </div>
                <div className='w-full flex items-center justify-center'>
                    <button onClick={() => navigate(`/platform2/research-practices/${data?.id}/`)} className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                        <div className='rounded-full px-[48px] py-[6px] ' style={{ border: '2px solid #eee', background: 'linear-gradient(to right, #015B6B, #00E9BA)' }}>
                            進入
                        </div>
                    </button>
                </div>
            </div>

            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
